import React from "react";
import styles from "./BrandExcellence.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRibbon, faPalette, faLeaf } from "@fortawesome/free-solid-svg-icons";

const BrandExcellence = () => {
  return (
    <section className={styles.excellenceSection}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.sectionTitle}>
          Crafting Excellence in Commercial Furniture
        </h2>

        <div className={styles.featureGrid}>
          {/* Premium Quality - Gold/Royal Theme */}
          <div className={`${styles.featureCard} ${styles.premiumCard}`}>
            <div className={`${styles.iconWrapper} ${styles.premiumIcon}`}>
              <FontAwesomeIcon icon={faRibbon} className={styles.icon} />
            </div>
            <h3 className={styles.featureTitle}>Premium Quality</h3>
            <p className={styles.featureDescription}>
              We select only the finest materials from trusted manufacturers,
              ensuring our furniture meets the highest standards of durability
              and elegance.
            </p>
          </div>

          {/* Design Versatility - Creative/Purple Theme */}
          <div className={`${styles.featureCard} ${styles.designCard}`}>
            <div className={`${styles.iconWrapper} ${styles.designIcon}`}>
              <FontAwesomeIcon icon={faPalette} className={styles.icon} />
            </div>
            <h3 className={styles.featureTitle}>Design Versatility</h3>
            <p className={styles.featureDescription}>
              From contemporary minimalism to timeless classics, our collections
              offer diverse styles to complement any commercial space.
            </p>
          </div>

          {/* Eco-Conscious - Green Theme */}
          <div className={`${styles.featureCard} ${styles.ecoCard}`}>
            <div className={`${styles.iconWrapper} ${styles.ecoIcon}`}>
              <FontAwesomeIcon icon={faLeaf} className={styles.icon} />
            </div>
            <h3 className={styles.featureTitle}>Eco-Conscious</h3>
            <p className={styles.featureDescription}>
              Sustainable practices guide our manufacturing, using eco-friendly
              materials and low-VOC finishes for healthier environments.
            </p>
          </div>
        </div>

        <div className={styles.brandStatement}>
          <p>
            At SCADEL FURNITURE, we don't just create furniture - we craft
            experiences. Each piece reflects our commitment to exceptional
            design, uncompromising quality, and sustainable practices. Serving
            discerning clients across India, we transform commercial spaces into
            statements of elegance and functionality.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandExcellence;
